<template>
  <div>
    <div>
      <h2 class="pb-4">
        What is your address?
      </h2>
    </div>
    <ValidationObserver ref="address">
      <ValidationProvider
        v-slot="{ errors }"
        name="line1"
        rules="required|max:60"
      >
        <v-text-field
          v-model="address.line1"
          label="Address Line 1"
          :error-messages="getErrorMessages(errors)"
        />
      </ValidationProvider>
      <v-text-field v-model="address.line2" label="Address Line 2" />
      <div class="dialog__form--city">
        <div class="item">
          <ValidationProvider
            v-slot="{ errors }"
            name="line3"
            rules="required|max:60"
          >
            <v-text-field
              v-model="address.line3"
              label="Town/City"
              :error-messages="getErrorMessages(errors)"
            />
          </ValidationProvider>
        </div>
        <div class="item">
          <ValidationProvider
            v-slot="{ errors }"
            name="postCode"
            rules="required|max:10"
          >
            <v-text-field
              v-model="address.postCode"
              label="Postcode"
              :error-messages="getErrorMessages(errors)"
            />
          </ValidationProvider>
        </div>
      </div>
      <ValidationProvider v-slot="{ errors }" name="country" rules="required">
        <Select
          v-model="address.country"
          label="Country"
          :items="countries"
          :loading="isLoadingCountries"
          item-text="label"
          item-value="id"
          :error-messages="getErrorMessages(errors)"
          autocomplete
        />
      </ValidationProvider>
    </ValidationObserver>
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { includes, merge, first } from "lodash";
import { FETCH_COUNTRIES } from "@/store/modules/data/actions";
import {
  GET_COUNTRIES,
  GET_IS_FETCHING_DATA
} from "@/store/modules/data/getters";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select from "@/components/common/Select";

const { mapGetters, mapActions } = createNamespacedHelpers(DATA_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "Address",
  components: {
    PrimaryButton,
    ValidationProvider,
    ValidationObserver,
    Select
  },
  created() {
    this.fetchCountries();
    this.address = merge(this.address, first(this.self.addresses));
  },
  data() {
    return {
      showValidationErrors: false,
      address: {
        line1: "",
        line2: "",
        line3: "",
        postCode: "",
        country: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      countries: GET_COUNTRIES,
      isLoadingCountries: GET_IS_FETCHING_DATA
    }),
    ...mapAuthState({
      self: state => state.userData
    })
  },
  methods: {
    ...mapActions({
      fetchCountries: FETCH_COUNTRIES
    }),
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    },
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.address.validate();
      if (isValid) {
        this.$emit("nextStep", { data: { address: this.address } });
      }
    },
    includes
  }
};
</script>

<style lang="scss"></style>
